import { render, staticRenderFns } from "./other-ex-module.vue?vue&type=template&id=3b0f7133&scoped=true"
import script from "./other-ex-module.vue?vue&type=script&lang=js"
export * from "./other-ex-module.vue?vue&type=script&lang=js"
import style0 from "./other-ex-module.vue?vue&type=style&index=0&id=3b0f7133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f7133",
  null
  
)

export default component.exports